import { render, staticRenderFns } from "./saved-searches.vue?vue&type=template&id=02b9cc14"
import script from "./saved-searches.vue?vue&type=script&lang=ts"
export * from "./saved-searches.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports